export default class emailSignup {

  constructor() {
    this.endpoint = '/wp-json/aauw/v1/subscribe';

    $(document).on('submit', '.aauw-email-signup-form', (e) => {
      this.emailSignupSubmit(e);
    });
  }

  emailSignupSubmit(event) {
    event.preventDefault();

    if (this.request && this.request.readyState !== 4) {
      // Don't try to start another POST when one is still in progress.
      return;
    }

    const $form = $(event.target),
          $errorContainer = $form.find('.aauw-email-signup-errors'),
          fieldData = {}
    ;

    $errorContainer.html('');

    $form.find('input[data-field]').each(function() {
      const $this = $(this);
      $this.val();
      fieldData[$this.data('field')] = $this.val();
    });

    // Final sanity check before submitting
    if (!fieldData.email) {
      throw 'No email value to submit!';
    }
    if (!fieldData.zipcode) {
      throw 'No zipcode value to submit!';
    }

    window.aauwLoading.addEvent('email-subscribe');

    this.request = $.post(
      // url
      this.endpoint,

      // data
      fieldData,

      // success
      (response) => {
        window.aauwLoading.endEvent('email-subscribe');

        if (response.status === 200) {
          // Trigger a custom event indicating success, in case a parent
          // component (e.g. Persistent Signup) needs it
          $form.trigger('aauw-email-signup-success');

          // Always trigger custom event to indicate success. If this is inside
          // an aauw-modal, this may be necessary to trigger "conversion" logic.
          // See src/components/modal/aauw-modals/aauw-modals.js
          $form.trigger('aauw-modal-conversion');

          $form.parent().find('.aauw-email-signup-success-message').css('display', '');
          $form.css('display', 'none');
        }

        if (typeof response.errors !== 'undefined') {
          let errorMarkup = '<ul>';
          response.errors.forEach(error => {
            errorMarkup += `<li class="aauw-email-signup-errors-error error-message -not-inline">${error}</li>`;
          });
          errorMarkup += '</ul>';

          $errorContainer.html(errorMarkup);
        }
      },

      // dataType
      'json'
    );
  }

}
